export default "__VITE_ASSET__DSL0UnKg__"